module.exports = __webpack_public_path__ + "static/media/mixirica.31f25539.jpeg";